import { inject, NgModule } from '@angular/core';
import { CanActivateFn, RouterModule, Routes } from '@angular/router';
import { MapService } from './services/map.service';
import { BookmarksFormComponent } from './components/sidebar/bookmarks/bookmarks-form/bookmarks-form.component';
import { BookmarksComponent } from './components/sidebar/bookmarks/bookmarks.component';
import { DynamicLayersComponent } from './components/sidebar/dynamic-layers/dynamic-layers.component';
import { EbwLayersConfiguratorComponent } from './components/sidebar/ebw-layers-configurator/ebw-layers-configurator.component';
import { OtdrComponent } from './components/sidebar/otdr/otdr.component';
import { CheckInOutComponent } from './components/sidebar/checkin-out/checkin-out.component';
import { QueryTabsComponent } from './components/sidebar/query/query-tabs/query-tabs.component';
import { QueryComponent } from './components/sidebar/query/query.component';
import { ShapeLayersConfiguratorComponent } from './components/sidebar/shape-configurator/shape-layers-configurator.component';
import { ValveComponent } from './components/sidebar/valve/valve.component';
import { TracingComponent } from './components/sidebar/tracing/tracing.component';
import { AnalisiSchiacciamentiComponent } from './components/sidebar/analisi-schiacciamenti/analisi-schiacciamenti.component';
import { PsaComponent } from './components/sidebar/psa/psa.component';
import { ControlliComponent } from './components/sidebar/controlli/controlli.component';
import { TrasmissioneAnteaComponent } from './components/sidebar/trasmissione-antea/trasmissione-antea.component';
import { CheckinAnalysisComponent } from './components/sidebar/checkin-analysis/checkin-analysis.component';
import { FiberJointsComponent } from './components/sidebar/fiber-joints/fiber-joints.component';

/** Valve usa il click sulla mappa per tutta la vita del pannello ("strong"): se c'è già uno strumento aperto la route non si apre */
const valveClickGuard: CanActivateFn = () => inject(MapService).canAcquireMapClick({ id: ValveComponent.CLICK_OWNER_ID, level: 'strong' });

const routes: Routes = [
  {
    path: 'layers',
    component: EbwLayersConfiguratorComponent
  },
  {
    path: 'dynamic-layers',
    component: DynamicLayersComponent
  },
  {
    path: 'shape-layers',
    data: { feature: 'shape-layers' },
    component: ShapeLayersConfiguratorComponent
  },
  {
    path: 'query',
    component: QueryComponent
  },
  {
    path: 'query-form',
    component: QueryTabsComponent,
    data: {
      child: true
    }
  },
  {
    path: 'bookmarks',
    component: BookmarksComponent
  },
  {
    path: 'bookmarks-form',
    component: BookmarksFormComponent,
    data: {
      child: true
    }
  },
  {
    path: 'valves',
    canActivate: [valveClickGuard],
    component: ValveComponent
  },
  {
    path: 'otdr',
    component: OtdrComponent
  },
  {
    path: 'psa',
    component: PsaComponent
  },
  {
    path: 'controlli',
    component: ControlliComponent
  },
  {
    path: 'trasmissione-antea',
    component: TrasmissioneAnteaComponent
  },
  {
    path: 'analisi-schiacciamenti',
    component: AnalisiSchiacciamentiComponent
  },
  {
    path: 'checkin-out',
    component: CheckInOutComponent
  },
  {
    path: 'tracing',
    component: TracingComponent
  },
  {
    path: 'checkin-analysis',
    component: CheckinAnalysisComponent
  },
  {
    path: 'fiber-joints',
    component: FiberJointsComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class MapRoutingModule {}
